import { Card, Image, Skeleton } from "antd";
import React, { useEffect, useState } from "react";
import { IntroductionContainer } from "../register-introduction/register-introduction.styled";
import { Box } from "@nubeteck/components";
import { LargeHeadingStyled } from "src/components/custom/texts/texts.styled";
import { RegisterSVG } from "src/assets";
import { getRegisterNoSubjectsPage } from "../../../Api/content";
import { useLocale } from "../../../i18n/localeContext";

function NoSubjectsText() {
  const { locale } = useLocale();
  const [page, setPage] = useState<any>(null);
  const [isLoadingContent, setIsLoadingContent] = useState(true);

  useEffect(() => {
    let cancel = false;
    setIsLoadingContent(true);
    getRegisterNoSubjectsPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          setPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => {
        if (!cancel) {
          setPage(null);
          setIsLoadingContent(false);
        }
      });
    return () => {
      cancel = true;
    };
  }, [locale]);

  return (
    <Card>
      <IntroductionContainer>
        <Box>
          <LargeHeadingStyled>
            {isLoadingContent ? (
              <Skeleton.Input active size="large" style={{ width: 400 }} />
            ) : (
              page?.empty_message || "Usted no tiene asignaturas pendientes para matricular."
            )}
          </LargeHeadingStyled>
        </Box>
        <Image
          src={RegisterSVG}
          width={285}
          alt={page?.illustration_alt || "Ilustración registro"}
          preview={false}
        />
      </IntroductionContainer>
    </Card>
  );
}

export default NoSubjectsText;
